<template>
  <v-layout class="translation" id="icon-translation">
    <v-menu offset-y :nudge-bottom="10" origin="center center" transition="scroll-y-transition" :max-width="275">
      <template v-slot:activator="{ on }">
        <v-img v-on="on" class="countrie-selected" :src="`static/countries/${items[item].icon}.png`" width="24" height="24"></v-img>
      </template>

      <v-list dense>
        <v-list-item-group v-model="item" color="primary">
          <v-list-item v-for="(item, i) in items" :key="i" :id="`translate-${item.icon}`" ripple @click="selectedCountries(item)">
            <v-list-item-icon>
              <v-img :src="`static/countries/${item.icon}.png`" width="24px" height="24px"></v-img>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
  </v-layout>
</template>

<script>
import store from '@/store';

export default {
  data() {
    return {
      item: 0,
      items: [
        {
          icon: 'pt-br',
          text: 'Português'
        },
        {
          icon: 'en',
          text: 'English'
        },
        {
          icon: 'es',
          text: 'Español'
        }
      ]
    };
  },

  methods: {
    selectedCountries(item) {
      this.selected = item;
    }
  }
};
</script>

<style lang="scss" scoped>
.translation {
  .countrie-selected {
    cursor: pointer;
  }
}
.v-menu__content {
  overflow: visible;
  contain: initial;
  max-width: 90%;
  border-bottom: 3px solid var(--v-primary-base);

  &:after {
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: rgba(136, 183, 213, 0);
    border-width: 8px;
  }
}

.theme--dark {
  .v-menu__content {
    &:after {
      border-bottom-color: #424242;
    }
  }
}

.theme--light {
  .v-menu__content {
    &:after {
      border-bottom-color: #ffffff;
    }
  }
}
</style>
